(function () {
    'use strict';
    // Directives used to organize our sidebar

    angular.module('GorillaBoy')
    .directive('breadcrumb', [
        '$rootScope',
        '$timeout',
        '$translate',
        'PathManager',
        'SessionManager',
        'SourceConstant',
        'AppConstants',
        function breadcrumb($rootScope, $timeout, $translate, PathManager, SessionManager, SourceConstant, AppConstants) {
            return {
                templateUrl: './shared/breadcrumb.html',
                scope: true,
                replace: true,
                link: function ($scope, $element, $attrs) {
                    var MAX_NUM_BREADCRUMB_BAR_ITEM = $attrs.maxBarItem? $attrs.maxBarItem : 3,
                        VIEW_TYPES = AppConstants.ViewTypes;
                    $scope.dropdownList = [];
                    $scope.barList = [];
                    $scope.showDropdownList = false;
                    $scope.showFriendlyName = function(item) {
                        if(typeof item === 'string') {
                            switch(item) {
                                case VIEW_TYPES.OWN_TYPE:
                                    return $translate.instant('TOP_NAV.MY_DOCUMENTS');
                                case VIEW_TYPES.RECYCLE_TYPE:
                                    return $translate.instant('TOP_NAV.RECYCLE_BIN');
                                case VIEW_TYPES.SHARED_TYPE:
                                    return $translate.instant('TOP_NAV.SHARED_WITH_ME');
                                case VIEW_TYPES.NOTE_TYPE:
                                    return $translate.instant('TOP_NAV.MYNOTE');
                            }
                        } else {
                            return item.Name;
                        }
                    };

                    $scope.goToLocation = function(location) {
                        if(typeof location === 'string') {
                            switch (location) {
                                case VIEW_TYPES.OWN_TYPE:
                                    $rootScope.showDocs();
                                    break;
                                case VIEW_TYPES.SHARED_TYPE:
                                    $rootScope.showShared();
                                    break;
                                case VIEW_TYPES.NOTE_TYPE:
                                    $rootScope.showMyNote();
                                    break;
                                case VIEW_TYPES.OUT_FOR_REVIEW_TYPE:
                                    $rootScope.showReview();
                                    break;
                                case VIEW_TYPES.AWAITING_FEEDBACK_TYPE:
                                    $rootScope.showFeedback();
                                    break;
                                case VIEW_TYPES.RECYCLE_TYPE:
                                    $rootScope.showRecycle();
                                    break;
                                case VIEW_TYPES.SEARCH_TYPE:
                                    $rootScope.showSearch(SessionManager.getLastSearched());
                                    break;
                            }
                        } else {
                            $rootScope.showFolder(location.Id);
                        }
                    };

                    $scope.breadcrumbKeydown = function(event, location) {
                        if (event.keyCode === AppConstants.KeyCodes.ENTER || event.keyCode === AppConstants.KeyCodes.SPACEBAR) { // enter or spacebar
                            $scope.goToLocation(location);
                        }
                    };

                    $scope.hasDropdownList = function() {
                        return $scope.dropdownList.length > 0;
                    };

                    $scope.hasOneItemInDropdownList = function() {
                        return $scope.dropdownList.length === 1;
                    };

                    $scope.toggleDropdownList = function() {
                        $scope.showDropdownList = !$scope.showDropdownList;
                    };

                    $scope.dropdownButtonClicked = function() {
                        // When there is only one item in the dropdown list, the toggle button of the 
                        // dropdown list will take user to that location implicitly
                        if ($scope.hasOneItemInDropdownList()) {
                            $scope.goToLocation($scope.dropdownList[0]);
                        }
                        // Removed toggleDropdownList call, because by turning this element into uib-dropdown, 
                        // toggling dropdown is already handled by that
                    };

                    $scope.dropdownButtonKeyDown = function(evt) {
                        if (evt.keyCode === AppConstants.KeyCodes.ENTER || evt.keyCode === AppConstants.KeyCodes.SPACEBAR) { // enter or spacebar
                            $timeout( function() {
                                evt.target.click();
                            }, 0);
                        }
                    };

                    $scope.$watch($attrs.path, function(path) {
                        if(!path) {
                            return;
                        }
                        $scope.dropdownList = [];
                        while(path.length > MAX_NUM_BREADCRUMB_BAR_ITEM) {
                            $scope.dropdownList.push(path.shift());
                        }
                        $scope.barList = path;

                    });
                }
            };
        }])
    .directive('currentFolderDropdown', [
        '$rootScope',
        'authenticatedUser',
        '$timeout',
        'AppConstants',
        function currentFolderDropdown($rootScope, authenticatedUser, $timeout, AppConstants) {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: './shared/breadcrumb_currentFolderDropdown.html',
            link: function($scope, $element, attrs) {
                $scope.showMoreOption = function() {
                    return !authenticatedUser.getUserInfo().MinimalUser;
                };

                var anchorKeydownHandler = function(event) {
                    if (event.keyCode === AppConstants.KeyCodes.ENTER || event.keyCode === AppConstants.KeyCodes.SPACEBAR) {
                        $timeout(function() {
                            event.target.click();
                        }, 0);
                    }
                };
                $scope.downloadKeydownHandler = anchorKeydownHandler;

                $scope.favoriteKeydownHandler = anchorKeydownHandler;

                $scope.shareLinkKeydownHandler = anchorKeydownHandler;

                $scope.inviteKeydownHandler = anchorKeydownHandler;

                $scope.renameKeydownHandler = anchorKeydownHandler;

                $scope.moveKeydownHandler = anchorKeydownHandler;

                $scope.deleteKeydownHandler = anchorKeydownHandler;

                $scope.removeMeFromShareKeydownHandler = anchorKeydownHandler;

                $scope.showActivityKeydownHandler = function(event) {
                    if (event.keyCode === AppConstants.KeyCodes.SPACEBAR) { // enter is already supported on anchor tag with href attribute
                        $timeout(function() {
                            event.target.click();
                        }, 0);
                    }
                };
            }
        };
    }]);
}());
